import { render } from "./MantenimientoPage.vue?vue&type=template&id=6cfda322&scoped=true"
import script from "./MantenimientoPage.vue?vue&type=script&lang=js"
export * from "./MantenimientoPage.vue?vue&type=script&lang=js"

import "./MantenimientoPage.vue?vue&type=style&index=0&id=6cfda322&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfda322"]])

export default __exports__